
// const MarkdownRenderer = ({ text }) => {
//   // 🧹 Clean & normalize text spacing
//   let processedText = text || "";
//   processedText = processedText
//   .replace(/##\s(.*?)/g, "### $1") // normalize headings
//   .replace(/\n{2,}\s*([*•\-0-9])/g, "\n$1") // remove gaps before lists
//   .replace(/\*\*(.*?)\*\*\n+/g, "**$1**\n") // remove gaps after bolds
//   .replace(/\n{3,}/g, "\n\n") // remove any remaining big gaps
//   .trim();

//   return (
//     <div className="ai-response-content">
//       <ReactMarkdown
//         rehypePlugins={[rehypeRaw]}
//         components={{
//           pre({ children }) {
//             const child = Array.isArray(children) ? children[0] : children;
//             const codeString =
//               typeof child?.props?.children === "string"
//                 ? child.props.children
//                 : String(child?.props?.children || "");
//             const lang =
//               typeof child?.props?.className === "string"
//                 ? child.props.className.replace("language-", "")
//                 : "text";
//             return (
//               <SyntaxHighlighter style={tomorrow} language={lang} PreTag="div">
//                 {codeString}
//               </SyntaxHighlighter>
//             );
//           },
//           code({ inline, children }) {
//             if (inline) {
//               return <code className="inline-code">{children}</code>;
//             }
//             return (
//               <div className="block-equation">
//                 <code>{children}</code>
//               </div>
//             );
//           },
//           strong: ({ children }) => (
//             <strong className="bold-title">{children}</strong>
//           ),
//           h3: ({ children }) => (
//             <h3 className="response-section-title">{children}</h3>
//           ),
//         }}
//       >
//         {processedText}
//       </ReactMarkdown>
//     </div>
//   );
// };
// import React from "react";
// import ReactMarkdown from "react-markdown";
// import rehypeRaw from "rehype-raw";
// import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
// import { tomorrow } from "react-syntax-highlighter/dist/esm/styles/prism";
// import "./MarkDownRenderer.css";

// const MarkdownRenderer = ({ text }) => {
//   // 🧹 Clean & normalize text spacing
//   let processedText = text || "";
//   processedText = processedText
//     .replace(/##\s(.*?)/g, "### $1") // normalize headings
//     .replace(/\n{2,}\s*([*•\-0-9])/g, "\n$1") // remove gaps before lists
//     .replace(/\*\*(.*?)\*\*\n+/g, "**$1**\n") // remove gaps after bolds
//     .replace(/\n{3,}/g, "\n\n") // remove any remaining big gaps
//     .trim();

//   return (
//     <div className="ai-response-content">
//       <ReactMarkdown
//         rehypePlugins={[rehypeRaw]}
//         components={{
//           // ⭐️ FIX 1: Custom Paragraph component to prevent <div> inside <p> ⭐️
//           p: ({ children }) => {
//             // This is a common pattern to check if the paragraph contains only one block-level child
//             if (
//               children &&
//               children.length === 1 &&
//               children[0].type === 'div' // If the child is a <div> (like the block-equation below)
//             ) {
//               // Return the children directly, unwrapping the block from the <p>
//               return children;
//             }
//             // Otherwise, render the standard paragraph
//             return <p>{children}</p>;
//           },

//           pre({ children }) {
//             const child = Array.isArray(children) ? children[0] : children;
//             const codeString =
//               typeof child?.props?.children === "string"
//                 ? child.props.children
//                 : String(child?.props?.children || "");
//             const lang =
//               typeof child?.props?.className === "string"
//                 ? child.props.className.replace("language-", "")
//                 : "text";
//             return (
//               <SyntaxHighlighter style={tomorrow} language={lang} PreTag="div">
//                 {codeString}
//               </SyntaxHighlighter>
//             );
//           },

//           code({ inline, children }) {
//             if (inline) {
//               return <code className="inline-code">{children}</code>;
//             }

//             // ⭐️ FIX 2: Ensure this block is correctly checked by the 'p' component
//             // This <div> is the element causing the nesting error.
//             return (
//               <div className="block-equation">
//                 <code>{children}</code>
//               </div>
//             );
//           },
//           strong: ({ children }) => (
//             <strong className="bold-title">{children}</strong>
//           ),
//           h3: ({ children }) => (
//             <h3 className="response-section-title">{children}</h3>
//           ),
//         }}
//       >
//         {processedText}
//       </ReactMarkdown>
//     </div>
//   );
// };

// export default MarkdownRenderer;

// export default MarkdownRenderer;
//////////////////////////////////////////////////////////working one ///////////////////
import React, { useState, useCallback } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import rehypeRaw from "rehype-raw";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { tomorrow } from "react-syntax-highlighter/dist/esm/styles/prism";
import { FaChevronDown, FaChevronUp, FaFileExcel, FaCopy, FaCheck } from 'react-icons/fa';
import { exportTableToExcel } from './exportTableToExcel';
import MermaidDiagram from './MermaidDiagram';
import './MarkDownRenderer.css';

/** Standalone copy button used inside code block headers */
const CopyCodeButton = ({ code }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(() => {
      // Fallback for browsers without clipboard API
      const ta = document.createElement('textarea');
      ta.value = code;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }, [code]);

  return (
    <button
      className={`code-copy-btn${copied ? ' copied' : ''}`}
      onClick={handleCopy}
      title={copied ? 'Copied!' : 'Copy code'}
      aria-label={copied ? 'Copied!' : 'Copy code'}
    >
      {copied ? <FaCheck className="copy-icon" /> : <FaCopy className="copy-icon" />}
      <span>{copied ? 'Copied!' : 'Copy'}</span>
    </button>
  );
};

/** Wraps SyntaxHighlighter with a header bar (language + copy button) */
const CodeBlock = ({ codeString, lang }) => (
  <div className="code-block-wrapper">
    <div className="code-block-header">
      <span className="code-block-lang">{lang || 'text'}</span>
      <CopyCodeButton code={codeString} />
    </div>
    <SyntaxHighlighter style={tomorrow} language={lang || 'text'} PreTag="div" customStyle={{ margin: 0, borderRadius: '0 0 8px 8px' }}>
      {codeString}
    </SyntaxHighlighter>
  </div>
);


const markdownComponents = {
  // --- Code blocks (fenced) ---
  pre({ children }) {
    const child = Array.isArray(children) ? children[0] : children;
    const codeString =
      typeof child?.props?.children === "string"
        ? child.props.children
        : String(child?.props?.children || "");
    const lang =
      typeof child?.props?.className === "string"
        ? child.props.className.replace("language-", "")
        : "text";
        if (lang.toLowerCase() === "mermaid") {
  return <MermaidDiagram chart={codeString} />;
}

    return <CodeBlock codeString={codeString} lang={lang} />;
  },

  // --- Inline code (`code`) ---
  code({ inline, children }) {
    return inline ? (
      <code className="inline-code">{children}</code>
    ) : (
      <code>{children}</code>
    );
  },

  // --- Custom heading styling ---
  h1: ({ children }) => (
    <h1 className="response-main-title">{children}</h1>
  ),
  h2: ({ children }) => (
    <h2 className="response-subtitle">{children}</h2>
  ),
  h3: ({ children }) => (
    <div className="response-title-container">
      <h3 className="response-section-title">{children}</h3>
    </div>
  ),

  // --- Custom lists ---
  ul: ({ children }) => <ul className="custom-bullet-list">{children}</ul>,
  // Forward `start` so that when react-markdown splits a numbered list into
  // multiple <ol> tags (blank lines between items), each starts at the right number.
  ol: ({ children, start }) => <ol className="custom-numbered-list" start={start}>{children}</ol>,
  li: ({ children }) => <li className="custom-list-item">{children}</li>,

  // --- Paragraphs ---
  p: ({ children }) => <p className="custom-paragraph">{children}</p>,

  // --- Strong/Bold ---
  strong: ({ children }) => <strong className="bold-text">{children}</strong>,

  // --- Links (open in new tab) ---
  a: ({ href, children }) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="markdown-link"
    >
      {children}
    </a>
  ),
};

const MarkdownRenderer = ({ text }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Check if text has RAG format
  const hasRAGFormat = text &&
    typeof text === 'string' &&
    text.includes('From documents:') &&
    text.includes('From general knowledge:') &&
    text.includes('From combined:');

  // ── Frontend safety net ──────────────────────────────────────────────────
  // Remove dangling table header rows (no separator row) from the END of a
  // section string.  This handles any old messages already stored in DB that
  // still contain the truncated table, so they display correctly.
  const removeIncompleteTrailingTable = (txt) => {
    if (!txt) return txt;
    const lines = txt.split('\n');
    const pipeIdxs = [];
    let i = lines.length - 1;
    while (i >= 0) {
      const s = lines[i].trim();
      if (s.startsWith('|')) { pipeIdxs.push(i); i--; }
      else if (s === '') { i--; }
      else { break; }
    }
    if (!pipeIdxs.length) return txt;
    const pipeLines = pipeIdxs.map(idx => lines[idx].trim()).filter(Boolean);
    const hasSep = pipeLines.some(line =>
      line.split('|').slice(1, -1).every(cell => cell.trim().replace(/-/g, '') === '')
    );
    if (hasSep) return txt;
    const firstPipe = Math.max(...pipeIdxs);
    let cut = firstPipe;
    while (cut > 0 && !lines[cut - 1].trim()) cut--;
    return lines.slice(0, cut).join('\n').trimEnd();
  };

  // Parse RAG sections using reliable index-based slicing
  const parseRAGSections = (fullText) => {
    if (!fullText) return { documents: '', generalKnowledge: '', combined: '' };

    const lower = fullText.toLowerCase();
    const docIdx = lower.indexOf('from documents:');
    const llmIdx = lower.indexOf('from general knowledge:');
    const combinedIdx = lower.indexOf('from combined:');

    let documents = '';
    let generalKnowledge = '';
    let combined = '';

    if (docIdx !== -1) {
      const end = llmIdx !== -1 ? llmIdx : (combinedIdx !== -1 ? combinedIdx : fullText.length);
      documents = fullText.substring(docIdx + 'from documents:'.length, end).trim();
    }
    if (llmIdx !== -1) {
      const end = combinedIdx !== -1 ? combinedIdx : fullText.length;
      generalKnowledge = fullText.substring(llmIdx + 'from general knowledge:'.length, end).trim();
    }
    if (combinedIdx !== -1) {
      combined = fullText.substring(combinedIdx + 'from combined:'.length).trim();
    }

    // Apply frontend safety net to each section
    return {
      documents: removeIncompleteTrailingTable(documents),
      generalKnowledge: removeIncompleteTrailingTable(generalKnowledge),
      combined: removeIncompleteTrailingTable(combined),
    };
  };

  // Regular markdown rendering component
  const renderMarkdown = (content) => {
    const stripped = (content || '')
      .replace(/\(\s*(\[\d+\]\s*,?\s*)+\)/g, '')      // strip ([1]), ([1], [2]), ([1][2]), etc.
      .replace(/(\[\d+\])+/g, '')                      // strip bare [1], [2][3], etc.
      .replace(/\(source[^)]*\)/gi, '')                 // strip (source), (source: ), etc.
      .replace(/\(\s*[,\s]*\)/g, '')                   // strip empty/comma-only parens: (), (, ), (  )
      .replace(/  +/g, ' ');                            // collapse double spaces
    const processedText = stripped.replace(/##\s(.*?)/g, "### $1");

    return (
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkMath]}
        rehypePlugins={[rehypeRaw, rehypeKatex]}
        // remarkPlugins={[remarkGfm]}
        components={{
          // --- Code blocks (fenced) ---
          pre({ children }) {
            const child = Array.isArray(children) ? children[0] : children;
            const codeString =
              typeof child?.props?.children === "string"
                ? child.props.children
                : String(child?.props?.children || "");
            const lang =
              typeof child?.props?.className === "string"
                ? child.props.className.replace("language-", "")
                : "text";

                if (lang.toLowerCase() === "mermaid") {
  return <MermaidDiagram chart={codeString} />;
}

            return <CodeBlock codeString={codeString} lang={lang} />;
          },

          // --- Inline code (`code`) ---
          code({ inline, children }) {
            return inline ? (
              <code className="inline-code">{children}</code>
            ) : (
              <code>{children}</code>
            );
          },

          // --- Custom heading styling ---
          h1: ({ children }) => (
            <h1 className="response-main-title">{children}</h1>
          ),
          h2: ({ children }) => (
            <h2 className="response-subtitle">{children}</h2>
          ),
          h3: ({ children }) => (
            <div className="response-title-container">
              <h3 className="response-section-title">{children}</h3>
            </div>
          ),

          // --- Custom lists ---
          ul: ({ children }) => <ul className="custom-bullet-list">{children}</ul>,
          // Forward `start` so that when react-markdown splits a numbered list into
          // multiple <ol> tags (blank lines between items), each starts at the right number.
          ol: ({ children, start }) => <ol className="custom-numbered-list" start={start}>{children}</ol>,
          li: ({ children }) => <li className="custom-list-item">{children}</li>,

          // --- Paragraphs ---
          p: ({ children }) => <p className="custom-paragraph">{children}</p>,

          // --- Strong/Bold ---
          strong: ({ children }) => <strong className="bold-text">{children}</strong>,

          // --- Links (open in new tab) ---
          a: ({ href, children }) => (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="markdown-link"
            >
              {children}
            </a>
          ),

          // --- Tables (from remarkGfm) with Excel export button ---
          table: ({ children }) => {
            // ── Recursively extract plain text from React children ──
            const getText = (node) => {
              if (node === null || node === undefined) return '';
              if (typeof node === 'string' || typeof node === 'number') return String(node);
              if (Array.isArray(node)) return node.map(getText).join('');
              if (node?.props?.children) return getText(node.props.children);
              return '';
            };

            // ── Walk the React tree to build a 2-D array ──
            const tableData = [];
            const childArray = React.Children.toArray(children);
            childArray.forEach((section) => {
              // section = <thead> or <tbody>
              React.Children.toArray(section?.props?.children).forEach((row) => {
                const cells = React.Children.toArray(row?.props?.children).map((cell) =>
                  getText(cell?.props?.children)
                );
                if (cells.length) tableData.push(cells);
              });
            });

            const handleExport = () => {
              // Build a meaningful filename from the header row (index 0)
              const headerRow = tableData[0] || [];
              const topicName = headerRow
                .filter(Boolean)
                .join('_')
                .toLowerCase()
                .replace(/[^a-z0-9_]+/g, '_')
                .replace(/_+/g, '_')
                .replace(/^_|_$/g, '')
                .slice(0, 40) || 'medhas_table';
              exportTableToExcel(tableData, topicName);
            };

            return (
              <div className="table-wrapper">
                <button
                  className="excel-export-btn"
                  onClick={handleExport}
                  title="Download table as Excel"
                >
                  <FaFileExcel className="excel-export-icon" />
                  Export to Excel
                </button>
                <table className="custom-table">{children}</table>
              </div>
            );
          },
          thead: ({ children }) => <thead>{children}</thead>,
          tbody: ({ children }) => <tbody>{children}</tbody>,
          tr: ({ children }) => <tr>{children}</tr>,
          th: ({ children }) => <th>{children}</th>,
          td: ({ children }) => <td>{children}</td>,
        }}
      >
        {processedText}
      </ReactMarkdown>
    );
  };

  // If RAG format, render with collapsible sections
  if (hasRAGFormat) {
    const sections = parseRAGSections(text);

    return (
      <div className="rag-answer-container">
        {/* Combined section (always visible) - SHOWN FIRST */}
        {sections.combined && (
          <div className="rag-section rag-combined">
            <h4 className="rag-section-title">✨ Answer</h4>
            <div className="rag-section-content">{renderMarkdown(sections.combined)}</div>
          </div>
        )}

        {/* Toggle Button */}
        <button
          className="rag-toggle-button"
          onClick={() => setIsExpanded(!isExpanded)}
          title={isExpanded ? 'Hide detailed sources' : 'Show detailed sources'}
        >
          {isExpanded ? (
            <>
              <FaChevronUp /> <span>Hide sources</span>
            </>
          ) : (
            <>
              <FaChevronDown /> <span>Show sources</span>
            </>
          )}
        </button>

        {/* Collapsible sections - SHOWN ONLY WHEN EXPANDED */}
        {isExpanded && (
          <div className="rag-expanded-sections">
            {sections.documents && (
              <div className="rag-section rag-documents">
                <h4 className="rag-section-title">📄 From quality documents</h4>
                <div className="rag-section-content">{renderMarkdown(sections.documents)}</div>
              </div>
            )}

            {sections.generalKnowledge && (
              <div className="rag-section rag-knowledge">
                <h4 className="rag-section-title">🤖 From general knowledge</h4>
                <div className="rag-section-content">{renderMarkdown(sections.generalKnowledge)}</div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  // Regular rendering for non-RAG messages
  return renderMarkdown(text);
};

export default React.memo(MarkdownRenderer);


// import React, { useState, useCallback } from "react";
// import ReactMarkdown from "react-markdown";
// import remarkGfm from "remark-gfm";
// import remarkMath from 'remark-math';
// import rehypeKatex from 'rehype-katex';
// import rehypeRaw from "rehype-raw";
// import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
// import { tomorrow } from "react-syntax-highlighter/dist/esm/styles/prism";
// import { FaChevronDown, FaChevronUp, FaFileExcel, FaCopy, FaCheck } from 'react-icons/fa';
// import { exportTableToExcel } from './exportTableToExcel';
// import MermaidDiagram from './MermaidDiagram';
// import './MarkDownRenderer.css';

// /** Standalone copy button used inside code block headers */
// const CopyCodeButton = ({ code }) => {
//   const [copied, setCopied] = useState(false);

//   const handleCopy = useCallback(() => {
//     navigator.clipboard.writeText(code).then(() => {
//       setCopied(true);
//       setTimeout(() => setCopied(false), 2000);
//     }).catch(() => {
//       const ta = document.createElement('textarea');
//       ta.value = code;
//       ta.style.position = 'fixed';
//       ta.style.opacity = '0';
//       document.body.appendChild(ta);
//       ta.select();
//       document.execCommand('copy');
//       document.body.removeChild(ta);
//       setCopied(true);
//       setTimeout(() => setCopied(false), 2000);
//     });
//   }, [code]);

//   return (
//     <button
//       className={`code-copy-btn${copied ? ' copied' : ''}`}
//       onClick={handleCopy}
//       title={copied ? 'Copied!' : 'Copy code'}
//       aria-label={copied ? 'Copied!' : 'Copy code'}
//     >
//       {copied ? <FaCheck className="copy-icon" /> : <FaCopy className="copy-icon" />}
//       <span>{copied ? 'Copied!' : 'Copy'}</span>
//     </button>
//   );
// };

// /** Wraps SyntaxHighlighter with a header bar (language + copy button) */
// const CodeBlock = ({ codeString, lang }) => (
//   <div className="code-block-wrapper">
//     <div className="code-block-header">
//       <span className="code-block-lang">{lang || 'text'}</span>
//       <CopyCodeButton code={codeString} />
//     </div>
//     <SyntaxHighlighter
//       style={tomorrow}
//       language={lang || 'text'}
//       PreTag="div"
//       customStyle={{ margin: 0, borderRadius: '0 0 8px 8px' }}
//     >
//       {codeString}
//     </SyntaxHighlighter>
//   </div>
// );

// const MarkdownRenderer = ({ text }) => {
//   const [isExpanded, setIsExpanded] = useState(false);

//   const hasRAGFormat = text &&
//     typeof text === 'string' &&
//     text.includes('From documents:') &&
//     text.includes('From general knowledge:') &&
//     text.includes('From combined:');

//   const removeIncompleteTrailingTable = (txt) => {
//     if (!txt) return txt;
//     const lines = txt.split('\n');
//     const pipeIdxs = [];
//     let i = lines.length - 1;
//     while (i >= 0) {
//       const s = lines[i].trim();
//       if (s.startsWith('|')) { pipeIdxs.push(i); i--; }
//       else if (s === '') { i--; }
//       else { break; }
//     }
//     if (!pipeIdxs.length) return txt;
//     const pipeLines = pipeIdxs.map(idx => lines[idx].trim()).filter(Boolean);
//     const hasSep = pipeLines.some(line =>
//       line.split('|').slice(1, -1).every(cell => cell.trim().replace(/-/g, '') === '')
//     );
//     if (hasSep) return txt;
//     const firstPipe = Math.max(...pipeIdxs);
//     let cut = firstPipe;
//     while (cut > 0 && !lines[cut - 1].trim()) cut--;
//     return lines.slice(0, cut).join('\n').trimEnd();
//   };

//   const parseRAGSections = (fullText) => {
//     if (!fullText) return { documents: '', generalKnowledge: '', combined: '' };

//     const lower = fullText.toLowerCase();
//     const docIdx = lower.indexOf('from documents:');
//     const llmIdx = lower.indexOf('from general knowledge:');
//     const combinedIdx = lower.indexOf('from combined:');

//     let documents = '';
//     let generalKnowledge = '';
//     let combined = '';

//     if (docIdx !== -1) {
//       const end = llmIdx !== -1 ? llmIdx : (combinedIdx !== -1 ? combinedIdx : fullText.length);
//       documents = fullText.substring(docIdx + 'from documents:'.length, end).trim();
//     }
//     if (llmIdx !== -1) {
//       const end = combinedIdx !== -1 ? combinedIdx : fullText.length;
//       generalKnowledge = fullText.substring(llmIdx + 'from general knowledge:'.length, end).trim();
//     }
//     if (combinedIdx !== -1) {
//       combined = fullText.substring(combinedIdx + 'from combined:'.length).trim();
//     }

//     return {
//       documents: removeIncompleteTrailingTable(documents),
//       generalKnowledge: removeIncompleteTrailingTable(generalKnowledge),
//       combined: removeIncompleteTrailingTable(combined),
//     };
//   };

//   const renderMarkdown = (content) => {
//     const stripped = (content || '')
//       .replace(/\(\s*(\[\d+\]\s*,?\s*)+\)/g, '')
//       .replace(/(\[\d+\])+/g, '')
//       .replace(/\(source[^)]*\)/gi, '')
//       .replace(/\(\s*[,\s]*\)/g, '')
//       .replace(/  +/g, ' ');
//     const processedText = stripped.replace(/##\s(.*?)/g, "### $1");

//     return (
//       <ReactMarkdown
//         remarkPlugins={[remarkGfm, remarkMath]}
//         rehypePlugins={[rehypeRaw, rehypeKatex]}
//         components={{
//           pre({ children }) {
//             const child = Array.isArray(children) ? children[0] : children;
//             const codeString =
//               typeof child?.props?.children === "string"
//                 ? child.props.children
//                 : String(child?.props?.children || "");
//             const lang =
//               typeof child?.props?.className === "string"
//                 ? child.props.className.replace("language-", "")
//                 : "text";

//             if (lang.toLowerCase() === "mermaid") {
//               // Safety check for streaming chunk without closing block yet
//               if (!codeString.trim() || !codeString.includes("\n")) {
//                 return <div className="mermaid-loading">Generating diagram...</div>;
//               }
//               return <MermaidDiagram chart={codeString}/>;
//             }

//             return <CodeBlock codeString={codeString} lang={lang} />;
//           },

//           code({ inline, children }) {
//             return inline ? (
//               <code className="inline-code">{children}</code>
//             ) : (
//               <code>{children}</code>
//             );
//           },

//           h1: ({ children }) => <h1 className="response-main-title">{children}</h1>,
//           h2: ({ children }) => <h2 className="response-subtitle">{children}</h2>,
//           h3: ({ children }) => (
//             <div className="response-title-container">
//               <h3 className="response-section-title">{children}</h3>
//             </div>
//           ),

//           ul: ({ children }) => <ul className="custom-bullet-list">{children}</ul>,
//           ol: ({ children, start }) => <ol className="custom-numbered-list" start={start}>{children}</ol>,
//           li: ({ children }) => <li className="custom-list-item">{children}</li>,
//           p: ({ children }) => <p className="custom-paragraph">{children}</p>,
//           strong: ({ children }) => <strong className="bold-text">{children}</strong>,

//           a: ({ href, children }) => (
//             <a href={href} target="_blank" rel="noopener noreferrer" className="markdown-link">
//               {children}
//             </a>
//           ),

//           table: ({ children }) => {
//             const getText = (node) => {
//               if (node === null || node === undefined) return '';
//               if (typeof node === 'string' || typeof node === 'number') return String(node);
//               if (Array.isArray(node)) return node.map(getText).join('');
//               if (node?.props?.children) return getText(node.props.children);
//               return '';
//             };

//             const tableData = [];
//             const childArray = React.Children.toArray(children);
//             childArray.forEach((section) => {
//               React.Children.toArray(section?.props?.children).forEach((row) => {
//                 const cells = React.Children.toArray(row?.props?.children).map((cell) =>
//                   getText(cell?.props?.children)
//                 );
//                 if (cells.length) tableData.push(cells);
//               });
//             });

//             const handleExport = () => {
//               const headerRow = tableData[0] || [];
//               const topicName = headerRow
//                 .filter(Boolean)
//                 .join('_')
//                 .toLowerCase()
//                 .replace(/[^a-z0-9_]+/g, '_')
//                 .replace(/_+/g, '_')
//                 .replace(/^_|_$/g, '')
//                 .slice(0, 40) || 'medhas_table';
//               exportTableToExcel(tableData, topicName);
//             };

//             return (
//               <div className="table-wrapper">
//                 <button className="excel-export-btn" onClick={handleExport} title="Download table as Excel">
//                   <FaFileExcel className="excel-export-icon" />
//                   Export to Excel
//                 </button>
//                 <table className="custom-table">{children}</table>
//               </div>
//             );
//           },
//           thead: ({ children }) => <thead>{children}</thead>,
//           tbody: ({ children }) => <tbody>{children}</tbody>,
//           tr: ({ children }) => <tr>{children}</tr>,
//           th: ({ children }) => <th>{children}</th>,
//           td: ({ children }) => <td>{children}</td>,
//         }}
//       >
//         {processedText}
//       </ReactMarkdown>
//     );
//   };

//   if (hasRAGFormat) {
//     const sections = parseRAGSections(text);

//     return (
//       <div className="rag-answer-container">
//         {sections.combined && (
//           <div className="rag-section rag-combined">
//             <h4 className="rag-section-title">✨ Answer</h4>
//             <div className="rag-section-content">{renderMarkdown(sections.combined)}</div>
//           </div>
//         )}

//         <button
//           className="rag-toggle-button"
//           onClick={() => setIsExpanded(!isExpanded)}
//           title={isExpanded ? 'Hide detailed sources' : 'Show detailed sources'}
//         >
//           {isExpanded ? (
//             <>
//               <FaChevronUp /> <span>Hide sources</span>
//             </>
//           ) : (
//             <>
//               <FaChevronDown /> <span>Show sources</span>
//             </>
//           )}
//         </button>

//         {isExpanded && (
//           <div className="rag-expanded-sections">
//             {sections.documents && (
//               <div className="rag-section rag-documents">
//                 <h4 className="rag-section-title">📄 From quality documents</h4>
//                 <div className="rag-section-content">{renderMarkdown(sections.documents)}</div>
//               </div>
//             )}

//             {sections.generalKnowledge && (
//               <div className="rag-section rag-knowledge">
//                 <h4 className="rag-section-title">🤖 From general knowledge</h4>
//                 <div className="rag-section-content">{renderMarkdown(sections.generalKnowledge)}</div>
//               </div>
//             )}
//           </div>
//         )}
//       </div>
//     );
//   }

//   return renderMarkdown(text);
// };

// export default React.memo(MarkdownRenderer);


